import data from "@/mixins/data";
import formable from "@/mixins/formable";

export default {
  mixins: [
    data,
    formable,
  ],
  data() {
    return {
      form: {
        scheduled_at: this.$moment().format('YYYY-MM-DD'),
      },
    }
  }
};
